






















import { Component, Prop, Vue } from 'vue-property-decorator'
import { Appointments, UserState, Locations, Resources, Employees, WaitlistItem, Templates, Messages } from '../models'
import { mapGetters } from 'vuex'

@Component({})
export default class Waitlist extends Vue {
  @Prop({ default: (): [] => [] }) items: WaitlistItem[]
  protected Locations = Locations
  protected Appointments = Appointments
  protected Resources = Resources
  protected Employees = Employees

  protected updateAppointmentsAndMessages: any

  get themeColor() {
    return Templates.themeColor
  }

  protected created() {
    Appointments.GET_APPOINTMENTS()
    Messages.GET_MESSAGES()
    this.updateAppointmentsAndMessages = setInterval(() => {
      Appointments.GET_APPOINTMENTS()
      Messages.GET_MESSAGES()
    }, 10000)
    // console.log(this)
  }

  protected beforeDestroy() {
    clearInterval(this.updateAppointmentsAndMessages)
  }

  protected logout() {
    UserState.LOGOUT()
  }

  protected resetLocation() {
    Locations.UNSET_ACTIVE_LOCATION()
  }

  protected getResourceNames(resourceIds: number[]): string {
    const resourceId = resourceIds[0]
    const resource = Resources.entitiesById[resourceId]
    return resource ? resource.name : ''
    // return resourceIds
    //   .map((id) => {
    //     const resource = Resources.entitiesById[id]
    //     return resource ? resource.name : ''
    //   })
    //   .join()
  }

  protected getEmployeeName(employeeId: number): string {
    const employee = Employees.entitiesById[employeeId]
    return employee ? employee.name : ''
  }
}
